import laptops from '../assets/laptops.jpg';

export const categories = [
  { name: "Phones", imageUrl: "https://www.cnet.com/a/img/resize/0302d07e10ba8dc211f7b4e25891ad46dda31976/hub/2023/02/05/f52fdc98-dafc-4d05-b20e-8bd936b49a53/oneplus-11-review-cnet-lanxon-promo-8.jpg?auto=webp&fit=crop&height=675&width=1200" },
  { name: "Laptops", imageUrl: laptops },
  { name: "Cameras", imageUrl: "https://placehold.co/150?text=Cameras" },
  { name: "Gaming", imageUrl: "https://placehold.co/150?text=Gaming" },
  { name: "Audio Devices", imageUrl: "https://placehold.co/150?text=Audio+Devices" }, // Combined category
  { name: "Graphics Card", imageUrl: "https://placehold.co/150?text=Graphics+Card" },
  { name: "Motherboard", imageUrl: "https://placehold.co/150?text=Motherboard" },
  { name: "CPU", imageUrl: "https://placehold.co/150?text=CPU" },
  { name: "Power Supply", imageUrl: "https://placehold.co/150?text=Power+Supply" },
  { name: "RAM", imageUrl: "https://placehold.co/150?text=RAM" },
  { name: "PC Accessories", imageUrl: "https://placehold.co/150?text=PC+Accessories" },
  { name: "Monitors", imageUrl: "https://placehold.co/150?text=Monitors" },
  { name: "Games", imageUrl: "https://placehold.co/150?text=Games" },
  { name: "Consoles", imageUrl: "https://placehold.co/150?text=Consoles" },
];